
































import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  props: {
    condominioInit: Array,
    disabled: Boolean,
  },
  data: () => ({
    email: [(v) => (v === '' || /^\w[\.-_\w]*@[\w-_]+([\.]\w+)*(\.\w{2,3})+$/.test(v)) || 'Email incorrecto'],
    openDialog: false,
    nuevoCondo: {
      creationDateTime: '',
      creationUsername: '',
      nombre: '',
      direccion: '',
      rfc: '',
      contacto: '',
    },
  }),
  methods: {
    modeloCondo() {
      return {
        creationDateTime: '',
        creationUsername: '',
        nombre: '',
        direccion: '',
        rfc: '',
        contacto: '',
      };
    },
    async modificarCondominio() {
      try {
        this.loading = true;
        this.nuevoCondo.lastModificationDateTime = this.$moment().format();
        this.nuevoCondo.lastModificationUsername = this.$store.getters.getUsername;
        const admin = this.$store.getters.getAdmin;
        const condo = this.nuevoCondo;
        const result = await this.$store.dispatch('updateCondo', {admin, condo} );
        console.debug('ResultADDCONDO: %o', result);
        this.$toast.success('Condominio modificado');
      } catch (e) {
        this.$toast.error(e.response.data.message);
      }
      console.log('CondominioImp %o', this.nuevoCondo);
      this.loading = false;
      this.openDialog = false;
      this.nuevoCondo = this.modeloCondo();
      this.$emit('reload', {});
    },
  },
  computed: {
    validateEmail() {
      if (/^\w[\.-_\w]*@[\w-_]+([\.]\w+)*(\.\w{2,3})+$/.test(this.nuevoCondo.contacto)) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    openDialog() {
      if (this.openDialog) {
        this.nuevoCondo = this.condominioInit[0];
      }
    },
  },
});
